// removed by extract-text-webpack-plugin
module.exports = {"errorPage":"ErrorPage-m__errorPage___3BRZi"};


//////////////////
// WEBPACK FOOTER
// ./containers/errorPage/ErrorPage.m.sass
// module id = OtY6
// module chunks = 0